// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  padding: 16px 24px;
  box-shadow: var(--shadow);
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: white;
}

.logo-icon {
  font-size: 32px;
}

.logo-text {
  font-size: 24px;
  font-weight: 800;
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.logout-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.main-content {
  flex: 1 1;
  padding: 20px;
  padding-bottom: 100px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: var(--text-light);
  padding: 8px 16px;
  border-radius: 12px;
  transition: all 0.2s;
}

.nav-item:hover {
  background: var(--background);
}

.nav-item.active {
  color: var(--primary);
}

.nav-item.active .nav-icon {
  transform: scale(1.2);
}

.nav-icon {
  font-size: 24px;
  transition: transform 0.2s;
}

.nav-label {
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  padding: 16px 24px;\n  box-shadow: var(--shadow);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  color: white;\n}\n\n.logo-icon {\n  font-size: 32px;\n}\n\n.logo-text {\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.user-menu {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-name {\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.logout-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.logout-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.main-content {\n  flex: 1;\n  padding: 20px;\n  padding-bottom: 100px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.bottom-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  display: flex;\n  justify-content: space-around;\n  padding: 8px 0;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n}\n\n.nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-decoration: none;\n  color: var(--text-light);\n  padding: 8px 16px;\n  border-radius: 12px;\n  transition: all 0.2s;\n}\n\n.nav-item:hover {\n  background: var(--background);\n}\n\n.nav-item.active {\n  color: var(--primary);\n}\n\n.nav-item.active .nav-icon {\n  transform: scale(1.2);\n}\n\n.nav-icon {\n  font-size: 24px;\n  transition: transform 0.2s;\n}\n\n.nav-label {\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
